export const ANALYTICS_EVENT = {
	WATCH_VIDEO: "lora:embed:watch-video",
	// CLICK_CTA: "lora:embed:click-cta",

	VIEW_VIDEO: "VIEW_VIDEO",
	SHARE_VIDEO: "SHARE_VIDEO",
	CLICK_ON_VIDEO: "CLICK_ON_VIDEO",
	CLICK_CTA: "CLICK_CTA",
	CLICK_POLL: "CLICK_POLL",
	CLICK_QUESTION_AND_ANSWER: "CLICK_QUESTION_AND_ANSWER",
	VIEW_VIDEO_IN_PLAYLISTT: "VIEW_VIDEO_IN_PLAYLIST",
	VIEW_VIDEO_INVIDIUAL: "VIEW_VIDEO_INVIDIUAL",
	LORA_VIEW_ITEM: "LORA_VIEW_ITEM",
};

export const GG_ANALYTIC_EVENTS = {
	ADD_TO_CART: "add_to_cart",
	PURCHASE: "purchase",
	BEGIN_CHECKOUT: "begin_checkout",
	CHECKOUT_FAILED: "CheckOutFailed",
	VIEW_ITEM: "view_item",
};
export const LORASTREAM_ANALYTIC_EVENTS = {
	WATCH_STREAM: "watch_stream",
	SHARE_STREAM: "share_stream",
	PRODUCT_CLICK: "product_click",
	ADD_TO_CART: "stream_add_to_cart",
	PURCHASE_SUCCESS: "purchase_success",
	PURCHASE_FAILED: "purchase_failed",
	PROCESS_CHECKOUT: "process_checkout",
	LORA_VIEW_ITEM: "lora_view_item",
	DECREASE_FROM_CART: "lora_decrease_from_cart",
	REMOVE_FROM_CART: "lora_remove_from_cart",
};

export const META_ID = process.env.META_ID;

let measurementIds = process.env.GA_MEASUREMENT_ID;
export const MEASUREMENT_ID = measurementIds ? measurementIds.split(",") : [];
export const CONTAINER_ID = process.env.GA_CONTAINER_ID;
export const ANALYTICS_SCRIPT = process.env.ANALYTICS_SCRIPT;
export const LPS_ANALYTICS_SCRIPT = process.env.LPS_ANALYTICS_SCRIPT;

export const TRACKING_COOKIE_KEY = {
	SV_CONTEXT: "_lora_sv_context",
	SV_ITEMS: "_lora_sv_items",
	SV_CART: "_lora_sv_cart",
};
